import React from 'react';
import './workflow.css';
import { SUBMISSION_STATUS } from './constants';
import { Guidance } from '../guidance';
import { FaRegEnvelope, FaRegEdit, FaRegEye, FaRegCheckCircle, FaRegPaperPlane } from "react-icons/fa";

export const Workflow = ({status}) => {

  return (
    <div className="workflow-container">
      <StatusBlock status={SUBMISSION_STATUS.SUBMITTED} formStatus={status}/>
      <HorizontalArrow />
      <StatusBlock status={SUBMISSION_STATUS.IN_PROGRESS} formStatus={status}/>
      <HorizontalArrow />
      <StatusBlock status={SUBMISSION_STATUS.DC_REVIEW} formStatus={status}/>
      <HorizontalArrow />
      <StatusBlock status={SUBMISSION_STATUS.PENDING_DISTRIBUTION} formStatus={status}/>
      <HorizontalArrow />
      <StatusBlock status={SUBMISSION_STATUS.COMPLETE} formStatus={status}/>
    </div>
  )
}

// status represents which status icon this will display
// formStatus represents the current status of the form
const StatusBlock = ({status, formStatus}) => {
  const isStatus = status === formStatus;
  let icon = null;
  let tooltipText = '';
  const fill = isStatus ? 'black' : '#c9c9c9';

  switch (status) {
    case SUBMISSION_STATUS.SUBMITTED:
      icon = FaRegEnvelope;
      tooltipText = 'The RFI has been received, but no action has been performed.';
      break;
    case SUBMISSION_STATUS.IN_PROGRESS:
      icon = FaRegEdit;
      tooltipText = 'A DTL has started to craft a response to this RFI.';
      break;
    case SUBMISSION_STATUS.DC_REVIEW:
      icon = FaRegEye;
      tooltipText = 'The response is awaiting a DC to review whether it will be marked as FOUO or Unclassified.';
      break;
    case SUBMISSION_STATUS.PENDING_DISTRIBUTION:
      icon = FaRegPaperPlane;
      tooltipText = 'The response has been reviewed and marked by a DC with the appropriate classification. Now the response needs to be sent back to the contractor manually. (This tool does not currently support automatic delivery.)';
      break;
    case SUBMISSION_STATUS.COMPLETE:
      icon = FaRegCheckCircle;
      tooltipText = 'The response has been sent back to the corresponding requester.';
      break;
  }
  
  return (
    <div className="status-container">
      <Guidance
          displayMode={'tooltip'}
          type="info"
          content={<div style={{textAlign: 'start'}}>{tooltipText}</div>}
          buttonSize="xl"
          icon={icon}
          iconFill={fill}
          from={'left'}
          width={'300px'}
          noTab={true}
      />
      <div className="status-text" style={isStatus ? {} : {color: fill}}>
        {status}
      </div>
    </div>
  )

}

const HorizontalArrow = () => {
  return (
    <div className="horizontal-arrow">
    </div>
  );
}